// extracted by mini-css-extract-plugin
module.exports = {"container":"VoterCard_container__3ntn4","imageContainer":"VoterCard_imageContainer__17F8Z","image":"VoterCard_image__3hZwO","text":"VoterCard_text__38lra"};